export default "__VITE_ASSET__C7O8dZ$B__"